import { useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import { MessageCircle, Send } from "lucide-react";
import { api, errMsg } from "@/lib/api";

const PROVIDER_LABEL = { mock: "Mock (tidak dikirim)", twilio: "Twilio WhatsApp (resmi Meta)", fonnte: "Fonnte" };
const ENV_HELP = {
  twilio: "Isi TWILIO_ACCOUNT_SID, TWILIO_AUTH_TOKEN, TWILIO_WHATSAPP_FROM (mis. +14155238886 untuk sandbox) di backend/.env; opsional TWILIO_CONTENT_SID untuk template pesan di luar jendela 24 jam.",
  fonnte: "Isi FONNTE_TOKEN (token device dari dashboard Fonnte) dan opsional FONNTE_SENDER di backend/.env, lalu pindai QR nomor pusat Sudut Nadi di Fonnte.",
  mock: "Ubah WA_PROVIDER di backend/.env menjadi twilio atau fonnte, isi kredensialnya, lalu restart backend.",
};

export function WaSettingsCard() {
  const [st, setSt] = useState(null);
  const [to, setTo] = useState("");
  const [sending, setSending] = useState(false);
  const load = useCallback(() => api.get("/admin/wa-settings").then((r) => setSt(r.data)), []);
  useEffect(() => { load(); }, [load]);
  const test = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      const { data } = await api.post("/admin/wa-settings/test", { to });
      if (data.status === "sent") toast.success(`Terkirim via ${data.provider}${data.ref ? ` (ref ${data.ref})` : ""}`);
      else if (data.status === "mocked") toast.info("Mode mock: pesan hanya dicatat, tidak dikirim");
      else toast.error(`Gagal: ${data.error}`);
      load();
    } catch (err) { toast.error(errMsg(err)); } finally { setSending(false); }
  };
  if (!st) return null;
  const tone = st.configured ? "border-emerald-200 bg-emerald-50 text-emerald-900" : st.provider === "mock" ? "border-amber-200 bg-amber-50 text-amber-900" : "border-rose-200 bg-rose-50 text-rose-900";
  const counts = st.delivery_counts || {};
  return (
    <div className={`rounded-lg border px-4 py-4 text-sm ${tone}`} data-testid="wa-settings-card">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <p className="font-medium inline-flex items-center gap-2"><MessageCircle size={15} strokeWidth={1.5} />Pengiriman WhatsApp: <span data-testid="wa-settings-provider">{PROVIDER_LABEL[st.provider] || st.provider}</span></p>
        <span className="text-xs" data-testid="wa-settings-status">{st.configured ? `Aktif${st.sender_masked ? ` · pengirim ${st.sender_masked}` : ""}${st.uses_template ? " · template" : ""}` : st.provider === "mock" ? "Belum disambungkan (MOCK)" : `Belum lengkap: ${st.missing_keys.join(", ") || "provider tidak dikenal"}`}</span>
      </div>
      <p className="mt-1 text-xs opacity-90">{ENV_HELP[st.provider] || ENV_HELP.mock} Pesan sistem (bayar, diterima, selesai, refund) dikirim dari satu nomor pusat Sudut Nadi, bukan dari nomor talent.{!st.admin_whatsapp_set && " Isi ADMIN_WHATSAPP agar notifikasi admin (talent baru, laporan, krisis) juga terkirim."}</p>
      <div className="mt-3 flex items-center gap-3 flex-wrap">
        <form onSubmit={test} className="flex gap-2 items-center" data-testid="wa-test-form">
          <input className="input-soft h-9 w-48 text-sm" placeholder="08xxxxxxxxxx" value={to} onChange={(e) => setTo(e.target.value)} required inputMode="tel" data-testid="wa-test-to" />
          <button className="btn-outline h-9 px-3 text-sm whitespace-nowrap shrink-0" disabled={sending} data-testid="wa-test-submit"><Send size={14} strokeWidth={1.5} />{sending ? "Mengirim..." : "Kirim pesan uji"}</button>
        </form>
        <span className="text-xs opacity-80" data-testid="wa-delivery-counts">Terkirim {counts.sent || 0} · Gagal {counts.failed || 0} · Mock {counts.mocked || 0}</span>
      </div>
    </div>
  );
}
